module.exports = "/_next/static/images/c6df87c671b4f432088e28470ab723c7-phone-with-app-open-and-card@2x-md.jpg.webp";